.container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--color-grayscale-light-slate);
}

.right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3.2rem;
  min-width: 12rem;
}
